export default __webpack_public_path__ + "static/media/pic12.065cee95.jpg";